import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import makeStyles from '@mui/styles/makeStyles';
import LinearProgress from '@mui/material/LinearProgress';

import UploadProgressState from './UploadProgressState';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
    width: '100%',
  },
  bar: {
    borderRadius: 5,
  },
  barSuccess: {
    backgroundColor: theme.palette.success.main,
  },
  barFailed: {
    backgroundColor: theme.palette.error.main,
  },
}));

const BorderLinearProgress = (props) => {
  const { state, progress } = props;
  const classes = useStyles();

  const variant = useMemo(() => {
    if (
      state === UploadProgressState.uploading ||
      state === UploadProgressState.idle ||
      state === UploadProgressState.success ||
      state === UploadProgressState.failed
    ) {
      return 'determinate';
    }
    return 'indeterminate';
  }, [state]);

  const getProgress = () => {
    switch (state) {
      case UploadProgressState.success:
      case UploadProgressState.failed: {
        return 100;
      }
      case UploadProgressState.idle: {
        return 0;
      }
      default: {
        return progress;
      }
    }
  };

  return (
    <LinearProgress
      variant={variant}
      value={getProgress()}
      classes={{
        root: classes.root,
        colorPrimary: classes.colorPrimary,
        bar: classnames(classes.bar, {
          [classes.barSuccess]: state === UploadProgressState.success,
          [classes.barFailed]: state === UploadProgressState.failed,
        }),
      }}
    />
  );
};

BorderLinearProgress.propTypes = {
  progress: PropTypes.number,
  state: PropTypes.oneOf([
    UploadProgressState.idle,
    UploadProgressState.processing,
    UploadProgressState.uploading,
    UploadProgressState.saving,
    UploadProgressState.success,
    UploadProgressState.failed,
  ]),
};

BorderLinearProgress.defaultProps = {
  progress: 0,
  state: UploadProgressState.idle,
};

export default BorderLinearProgress;
